import React, { useState } from "react";
import { useQuery } from 'react-query'
import { Stack } from "react-bootstrap";

import { getEventGames } from "data/Querys"


import useViewport from "components/general/useViewPort";
import NotAvailable from 'components/common/NotAvailable'
import { useUrlFriendlyToParameters, useGetPath } from "helpers/urlFriendly";
import { getEventRSC } from "helpers/rsc"

import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import Selector_Event from "components/common/selectors/SelectorEvent";

import Label from "components/general/Label";
import Phase from 'components/common/selectors/selector-phase/Phase';
import { useGetConfigSports } from 'helpers/commonCodes';
import SelectorPhaseCombo from "components/common/selectors/selector-phase/selectorPhaseCombo";
import UnitsSlide from "./selector-unit/Unit";
import { sortDataByFieldDesc } from "helpers/utils";



export default function FilterBar() {
    const [phaseCombo, setPhaseCombo] = useState();
    const { data, show } = GetDataToDraw({ phase: phaseCombo });
    const { mirs_discipline } = useUrlFriendlyToParameters();

    //    const [show, setShow] = useState(true);
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    if (isMobile) return ''

    //get if Selector phase can be show and its data

    return (
        <section className='container'>
            <Stack direction="horizontal" className="selectors-container">
                <SelectorDiscipline display_type="combo" page="schedule" />
                <Selector_Event page="schedule" />
                {show &&  < SelectorPhaseCombo setState={setPhaseCombo} />}
            </Stack>
            {show && <UnitsSlide items={data} />}
        </section>
    )
}

function GetDataToDraw({ phase: phase }) {
    const { mirs_rsc, mirs_language, mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const params = { 'mirs_competition': mirs_competition, 'mirs_discipline': mirs_discipline };
    const dataConfigSport = useGetConfigSports(params);
    const hasRibbon = dataConfigSport?.hasRibbon !== undefined ? dataConfigSport.hasRibbon : true;

    const _event = getEventRSC(mirs_rsc)
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['unitsEvents', mirs_competition, _event, mirs_language],
            queryFn: getEventGames,
            refetchInterval: 60000,
        }
    );

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return (''); }
    if (!data) { return (<div className='container'><NotAvailable /></div>); }




    let phases = Array.isArray(data?.event?.phases) && data?.event?.phases?.filter(item => item.order)
    sortDataByFieldDesc(phases, "order", false);

    let phasesFilter
    if (phase) {
        phasesFilter = Array.isArray(data?.event?.phases) && data?.event?.phases?.filter(item => item.order && item.code === phase)
    } else {
        phasesFilter = phases
    }

    const dtFilter = {
        ...data,
        event: {
            ...data.event,
            phases: phasesFilter
        }
    }
    const dataFilter = dtFilter;
    let _show
    if (Array.isArray(dataFilter?.event.phases) && (phases.length > 1 || dataFilter?.event.phases[0].length > 1)) {
        _show = hasRibbon && true
    } else {
        _show = false
    }
    return { data: dataFilter, show: _show }
}

